module.exports = __webpack_public_path__ + "img/Michael_Snyder.8a3e5253.jpeg";